export default __webpack_public_path__ + "static/media/element_spec_11.7e590c5d.webp";